import axios from 'axios';
import { trackBeginCheckout } from '../utils/analytics';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export interface CheckoutSession {
  sessionId: string;
  url: string;
}

/**
 * Create a Stripe checkout session for subscription purchase
 * @param priceId - Stripe price ID (monthly or annual)
 * @param authToken - Supabase JWT token
 */
export const createCheckoutSession = async (
  priceId: string,
  authToken: string
): Promise<CheckoutSession> => {
  const response = await axios.post<{ success: boolean; data: CheckoutSession }>(
    `${API_BASE_URL}/api/stripe/create-checkout-session`,
    { priceId },
    {
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.data.success) {
    throw new Error('Failed to create checkout session');
  }

  // Every web checkout (membership page, after sign-in, auth callback) goes
  // through here right before the redirect to Stripe. No-op unless GA4 is on.
  trackBeginCheckout(priceId);

  return response.data.data;
};

// Legacy portal + cancellation helpers removed in favor of Stripe Customer Portal redirect
